export const GET_USER = "GET_USER";
export const RESET_PASSWORD = "RESET_PASSWORD";
export const EDIT_PASSWORD = "EDIT_PASSWORD";
export const EDIT_PROFILE = "EDIT_PROFILE";
export const CLEAR_USER = "CLEAR_USER";
export const ADD_FCM_TOKEN = "ADD_FCM_TOKEN";
export const USER_LOADING_START = "USER_LOADING_START";
export const USER_LOADING_END = "USER_LOADING_END";
export const USER_CREATED = "USER_CREATED";
